import { render, staticRenderFns } from "./department_bill_details.vue?vue&type=template&id=2b878852&scoped=true&"
import script from "./department_bill_details.vue?vue&type=script&lang=js&"
export * from "./department_bill_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b878852",
  null
  
)

export default component.exports